import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';
import { WareneingaengeService } from '../../features/wareneingaenge/services/wareneingaenge.service';

export const posWareneingangLockGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const wareneingaengeService = inject(WareneingaengeService);
  const toastService = inject(ToastService);
  const router = inject(Router);

  if (!authService.isPosSession()) {
    return true;
  }

  const wareneingangId = route.paramMap.get('id');

  if (!wareneingangId) {
    return router.createUrlTree(['/wareneingaenge']);
  }

  return wareneingaengeService
    .acquireLock(
      wareneingangId,
      authService.getLoggedInUserName()
    )
    .pipe(
      map((result) => {
        if (result.success) {
          return true;
        }

        toastService.warning(
          'Bearbeitung nicht möglich',
          result.lockedBy
            ? `Der Wareneingang wird aktuell von ${result.lockedBy} bearbeitet.`
            : 'Der Wareneingang konnte nicht gesperrt werden.'
        );

        return router.createUrlTree(['/wareneingaenge']);
      })
    );
};